<template>
     <div class="h5exhibitionHallBody">
       <div class="exhibitionHall"   :style="{
            minHeight: `calc(100vh - ${topHeight || 0}px )`,
        }">
          <div class="iframe"  :style="{
            minHeight: `calc(100vh - ${topHeight}px - 3rem)`,
        }">
        <iframe :src="xsyztVr.ztvr" width="100%"  frameborder="0" :style="{
           minHeight: `calc(100vh - ${topHeight}px - 1.8rem)`,
            overflow: 'hidden',
        }"></iframe>
                 
          </div>
          <div class="exhibitionHallBottom" v-if="xsyztVr.ztvr">
                  <div class="exhibitionHallBottom_footer">
                      <div>云展聚光  名企同台  优品共耀</div>
                      <div style="margin-top: .28rem;">即刻入驻 抢占云席 18910514060</div>
                  </div>
          </div>
    </div>
     </div>
</template>
 
<script>
import { getCurrentInstance,ref,watch,computed,onMounted,nextTick} from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "exhibitionHall",
    components:{
  },
    props:{
      topHeight: {
        type: Number,
        default: 0
      }
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    let articleData = ref({});
    const ruleFormRef=ref(null)
    const ruleForm= ref({})
    let articleId=ref(route.query.articleId);
    const xsyztVr=ref({})
    const getDetails=()=>{
      proxy.$request({
        url: "XSYZT_LIST",
        method: "post",
        data:{}
      }).then((res) => {
        if (res.data.code == "000") {
          xsyztVr.value=res.data.result[0]
          console.log( xsyztVr.value,' xsyztVr.value')
        }
      }).catch((err) => {
        console.log(err);
      });
		}
    getDetails()
        const notaryServicesref = ref(null);
        const footerHeight = ref(0);
        onMounted(async () => {
        await nextTick();
        // if(notaryServicesref.value){
        //     footerHeight.value = notaryServicesref.value.offsetHeight
        // }
        
            // window.addEventListener('resize', ()=>{
            // if(notaryServicesref.value){
            //     footerHeight.value = notaryServicesref.value.offsetHeight
            // }
            // });
        });
    return {
      xsyztVr
    };
  },
};
</script>

 
<style lang="less" scoped>
.h5exhibitionHallBody{
.exhibitionHall {
  background: #000;
    .exhibitionHallBottom{
      // margin-top: -.2rem;
      
      background: #000;
            width:100%;
            height:1.8rem;
             background:url('@/assets/images/notaryServicers/h5exhibitionHallBottom.png') no-repeat;
            background-size:100%  100% ;
            margin-top: -.06rem;
            // position: absolute;
            // bottom:0;
            // left:0;
            // z-index:0;
            .exhibitionHallBottom_footer {
            font-size: .36rem;
            color: #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            height: 100%;
            padding-top: .2rem;
              //  margin: 0 auto;
              // width: 1200px;
              // display: flex;
              // height: 100%;
              // justify-content: space-between;
              // align-items: center;
              // font-family: "REEJI-CloudHuPoGBT", sans-serif;
              // font-family: "Microsoft YaHei", "PingFang SC", "Helvetica Neue", Arial, sans-serif;
              // font-weight: normal;
              // font-size: 40px;
              // color: #FFFFFF;
              // line-height: 24px;
            }
        }

}
        .exhibitionHallBody_footer {
              width:100%;
              height:75px;
              background:url('@/assets/images/notaryServicers/footerExh.png') no-repeat;
              background-size: 100% 100% ;
               margin-top: -3px;
              .exhibitionHallBottom_footer {
                 margin: 0 auto;
                width: 1200px;
                display: flex;
                height: 100%;
                justify-content: space-between;
                align-items: center;
                font-weight: 400;
                font-size: 13px;
                color: #FFFFFF;
              }
        }
}
</style>